import axios from "axios";

const api = axios.create({
  baseURL: '/api/v0/',
  withCredentials: true,
});

export function jobberAccountName(state: string|null) {
  return api.get("/jobber/account_name", {
    headers: {
      'X-INTEGRATION-STATE': state
    }
  });
}

export function jobberAuthorize(code: string|null, state: string|null) {
  return api.post("/jobber/authorize", {}, {
    headers: {
      'X-JOBBER-CODE': code,
      'X-INTEGRATION-STATE': state,
    }
  });
}

export function jobberRedirectUrl(state: string|null) {
  return api.get("/jobber/redirect_url", {
    headers: {
      'X-INTEGRATION-STATE': state
    }
  });
}

export function xeroAccountName(state: string|null) {
  return api.get("/xero/account_name", {
    headers: {
      'X-INTEGRATION-STATE': state
    }
  });
}

export function xeroAuthorize(code: string|null, state: string|null) {
  return api.post("/xero/authorize", {}, {
    headers: {
      'X-XERO-CODE': code,
      'X-INTEGRATION-STATE': state,
    }
  });
}

export function xeroRedirectUrl(state: string|null) {
  return api.get("/xero/redirect_url", {
    headers: {
      'X-INTEGRATION-STATE': state
    }
  });
}

export function getXeroAccounts(type: string, state: string|null) {
  return api.get("/xero/accounts/" + type, {
    headers: {
      'X-INTEGRATION-STATE': state,
    }
  });
}

export function saveXeroAccounts(ledgerAccount: string, bankAccount: string, state: string|null) {
  return api.post("/xero/save_accounts", {
    ledger_account_id: ledgerAccount,
    bank_account_id: bankAccount,
  }, {
    headers: {
      'X-INTEGRATION-STATE': state
    }
  });
}

export default api;
